import React, {useState} from 'react';
import { GoogleMap, LoadScript, Marker, Polygon } from '@react-google-maps/api';
import {Table, Button} from 'react-bootstrap';
import "./App.css";
import AirQualityForecastRegions from './AirQualityForecastRegions';
import StationsData from './StationsData';
import CustomMapControl from './CustomMapControl';

//const API_KEY = "AIzaSyBBVfEVGjXXaPB7oQqcm_5Svoi3vr7h8d4";
const RURAL_STATIONS = new Set(['15020', '16015', '18007', '49005', '49010', '51010']);
//const fields = ['id', 'station_name', 'station_location', 'year', 'latitude', 'longitude', 'air_intake', 'type', 'AQHI', 'NO2', 'PM25', 'O3', 'SO2', 'CO', 'TRS'];
const fields = ['NO2', 'PM25', 'O3', 'SO2', 'CO', 'TRS'];
/*
const notes = {
  //id: 'station identfication number',
  //year: 'year station began monitoring',
  //air_intake: 'height of air intake above ground (m)',
  //type: 'type of monitoring site: A = ambient, RS = road-side, C = CAAQS, N = NAPS',
  //AQHI: 'Air Quality Health Index site',
  T: 'telemetry',
  NO2: 'nitrogen dioxide',
  PM25: 'fine particulate matter',
  O3: 'ground-level ozone',
  SO2: 'sulphur dioxide',
  CO: 'carbon monoxide',
  TRS: 'total reduced sulphur'
};
*/
const POLYGON_OPTIONS = {
  strokeColor: `#000000`,
  fillColor: `#00ff00`,
  fillOpacity: 0.1,
  strokeWeight: 2,
  clickable: false,
  editable: false,
  zIndex: 1,
};

const getMultipolygons = () => {
  return AirQualityForecastRegions.features.filter(f => f.geometry.type === 'MultiPolygon').map(f => f.geometry.coordinates.map(coors => coors[0].map(coor => ({lng: coor[0], lat: coor[1]}))));
};
const COLOR_DICT = {
  'Urban': {
    color: '#0000FF',
    type: "circle"
  },
  'Rural': {
    color: '#FF00FF',
    type: "square"
  }
};
const SvgIcon = (props) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="12">
    {
      props.type === 'square' ? <rect width="12" height="12" style={{
        fill: props.color,
        stroke: 'gray',
        strokeWidth: 1
      }} /> : <circle cx="6" cy="6" r="6" style={{
        fill: props.color,
        stroke: 'gray',
        strokeWidth: 1
      }} />  
    }
  </svg>);
};

const PAGE_SIZE = 5;
const createPageButtons = (index, setIndex, number_of_records) => {
  return <div style={{textAlign: "center"}}>
            <Button 
              variant="secondary" 
              aria-label="Previous" 
              style={{marginRight: "10px", float: "left"}} 
              disabled={index <= 0} 
              onClick={(e) => setIndex(index - PAGE_SIZE)}>
                Previous
            </Button>
            Page {index / PAGE_SIZE + 1}
            <Button variant="secondary" 
              aria-label="Next" 
              style={{marginRight: "10px", float: "right"}} 
              disabled={index + PAGE_SIZE >= number_of_records}  
              onClick={(e) => setIndex(index + PAGE_SIZE)}>
                &nbsp;&nbsp;Next&nbsp;&nbsp;
              </Button>
  </div>;
};

const TableIcon = (props) => {
  return <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" 
    onClick={() => props.onClickStation(props.id)}>
      {
        RURAL_STATIONS.has(props.id) ? 
          <rect width="12" height="12" style={{
            fill: '#FF00FF',
            stroke: 'gray',
            strokeWidth: 1
          }} /> : <circle cx="6" cy="6" r="6" style={{
            fill: '#0000FF',
            stroke: 'gray',
            strokeWidth: 1
          }} />  
      }
  </svg>;
};
const MapLegend = (props) => {
  return <CustomMapControl>
    <div style={{backgroundColor:'#ffffff',borderStyle:'solid',borderWidth:'10px',borderColor:'#ccc',marginTop:'5px',marginLeft:'5px'}}>
        <h6>Legend</h6>
        {
            Object.keys(COLOR_DICT).map((id, index) => 
                <div key={index} style={{textAlign: "left", marginLeft: '10px', fontSize: '15px'}}>
                    <SvgIcon color={COLOR_DICT[id].color} type={COLOR_DICT[id].type} />&nbsp;&nbsp;{id}&nbsp;Station&nbsp;&nbsp;&nbsp;
                </div>
            )
        }
        <div style={{textAlign: "left", marginLeft: '10px', fontSize: '15px'}}>
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="12">
            <rect width="24" height="12" style={{
              fill: "#00FF00",
              fillOpacity: 0.4,
              stroke: 'black',
              strokeWidth: 2
            }} />
          </svg>&nbsp;&nbsp;Air Quality Forecast Region
        </div>
    </div>
  </CustomMapControl>;
};

const StationMarker = (props) => {
  const station = props.station;
  const onClickStation = props.onClickStation;
  return <Marker 
    position={{lng: station[5], lat: station[4]}}
    onClick={(e) => {onClickStation(station[0])}}
    title = {station[1]}
    icon={{
        path:  RURAL_STATIONS.has(station[0]) ? "M -20 -20 H 20 V 20 H -20 L -20 -20" : "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
        fillColor: RURAL_STATIONS.has(station[0]) ? '#FF00FF' : '#0000FF',
        fillOpacity: .99,
        title: station[1],
        //anchor: new window.google.maps.Point(0,0),
        strokeWeight: 1,
        scale: 0.3
    }}
  />;
};

const HighlightedStationMarker = (props) => {
  const station = props.station;
  return <Marker 
    position={{lng: station[5], lat: station[4]}}
    onClick={(e) => {}}
    title={station[1]}
    icon={{
        path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
        fillColor: '#FF0000',
        fillOpacity: .99,
        //anchor: new window.google.maps.Point(0,0),
        strokeWeight: 1,
        scale: 0.8
    }}
  />    
};

const OntarioAirQualityMonitoringStationsMap = (props) => {
    //const [selectedStation, setSelectedStation] = useState(-1);
    const [selectedStationId, setSelectedStationId] = useState('00000');

    const [center, setCenter] = useState({
      lat: 50.01,
      lng: -85.323214,
    });
    const [zoom, setZoom] = useState(5);
    const [tableIndex, setTableIndex] = useState(0);
    //const [map, setMap] = useState(null);
    const onMouseMove = (e) => {
      //setInfoBoxLocation({lng: e.latLng.lng(), lat: e.latLng.lat()});
    };
    const getFieldName = (field) => {
      const lookupTable = {
        "NO": "NO",
        "NO2": "NO\u2082",
        "NOX": "NO\u2093",
        "PM25": "PM\u2082.\u2085",
        "O3": "O\u2083",
        "SO2": "SO\u2082",
        "CO": "CO"
      };
      if (lookupTable.hasOwnProperty(field)) {
        return lookupTable[field];
      }
      return field.toUpperCase().replace('_', ' ');
    };
    const getFieldFullName = (field) => {
      const lookupTable = {
        //"NO": "NO",
        "NO2": "nitrogen dioxide",
        //"NOX": "NO\u2093",
        "PM25": "fine particulate matter",
        "O3": "ozone",
        "SO2": "sulphur dioxide",
        "CO": "carbon monoxide",
        "TRS": "total reduced sulphur"
      };
      if (lookupTable.hasOwnProperty(field)) {
        return lookupTable[field];
      }
      return field.toUpperCase().replace('_', ' ');
    };
    const onClickStation = (station_id) => {
      const index = StationsData.findIndex(items => items[0] === station_id);
      //setSelectedStation(index);
      setSelectedStationId(StationsData[index][0]);
      const lng = StationsData[index][5];
      const lat = StationsData[index][4];
      setCenter({lng, lat});
      setZoom(15);
      const tableIndex = StationsData.sort((a,b) => { 
          return a[1] < b[1] ? -1 : 1;
        }).findIndex(station => station[0] === station_id);
      setTableIndex(Math.floor(tableIndex / PAGE_SIZE) * PAGE_SIZE);
    };
    return (
      <div className="App">
        <LoadScript
          id="script-loader"
          googleMapsApiKey={window.API_KEY}
          language="en"
          region="ca"
        >
          <GoogleMap
            id='example-map'
            mapContainerClassName="App-map"
            zoom={zoom}
            center={center}
            onClick={(e) => {
              setSelectedStationId('00000'); 
              setTableIndex(0);
              setZoom(5); 
              setCenter({
                lat: 50.01,
                lng: -85.323214,
              })}}
            onMouseMove={onMouseMove}
            onLoad={map => {
              //setMap(map);
              //const bounds = new window.google.maps.LatLngBounds();
              //map.fitBounds(bounds);
            }}
          >
            <MapLegend />
            {
              (!selectedStationId || selectedStationId === '00000') ? null : 
                <HighlightedStationMarker station={StationsData.find(station => station[0] === selectedStationId)} />
            }
            {
                StationsData.map((station, index) =>
                    <StationMarker key={index} station={station} onClickStation={onClickStation} />
                )
            }
            {
                AirQualityForecastRegions.features.filter(f => f.geometry.type === 'Polygon')
                  .map((g, index) => 
                    <Polygon key={index} path={g.geometry.coordinates[0].map(coor => ({lng: coor[0], lat: coor[1]}))} options={POLYGON_OPTIONS} onClick={(e) => console.log(e)}/>
                  )
            }
            {
              getMultipolygons().map((coors_array, index1) => {
                return coors_array.map((coors, index2) => 
                  <Polygon key={index1 * 1000 + index2} path={coors} options={POLYGON_OPTIONS} onClick={(e) => console.log(e)}/>                
                )
              })
            }
          </GoogleMap>
        </LoadScript>
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Station Name</th>
              <th>Station Location</th>
              {fields.map((field, index) => <th key={index}><abbr title={getFieldFullName(field)}>{getFieldName(field)}</abbr></th>)}
            </tr>
          </thead>
          <tbody>
            {StationsData.sort((a,b) => { 
                  return a[1] < b[1] ? -1 : 1;
              })
              .filter((item, index) => index >= tableIndex && index < (tableIndex + PAGE_SIZE))
              .map((items, index) =>
              <tr key={index}>
                <td>
                  {
                    selectedStationId === items[0] ? 
                    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#FF0000"/></svg>
                    : <TableIcon id={items[0]} onClickStation={onClickStation}/>
                  }
                </td>
                {items.filter((item, idx) => ![0, 3, 4, 5, 6, 7, 8].includes(idx)).map((item, idx) =>
                  <td key={idx} style={(idx === 1 || idx === 2) ? {'textAlign': 'left'} : {'textAlign': 'center'}}>{item}</td>
                )} 
              </tr>
            )}
          </tbody>
        </Table>
        <div>
          {createPageButtons(tableIndex, setTableIndex, StationsData.length)}
        </div>
      </div>
     );
  };
  export default OntarioAirQualityMonitoringStationsMap;
  